const WEBSITE_CHAT_MAX_WIDTH_PX = 940;
const CHAT_COMPOSER_HORIZONTAL_PADDING_PX = 20;
const CHAT_COMPOSER_ACTION_GAP_PX = 8;
const CHAT_COMPOSER_SEND_BUTTON_WIDTH_PX = 36;
const VOICE_CONTROL_BUTTON_WIDTH_PX = 32;
const VOICE_CONTROL_GROUP_GAP_PX = 12;

export const COMPOSER_TEXTAREA_MIN_HEIGHT_PX = 48;
export const COMPOSER_TEXTAREA_MAX_HEIGHT_PX = 200;

export const VOICE_WAVEFORM_BAR_WIDTH = 2;
export const VOICE_WAVEFORM_BAR_GAP = 3;
export const VOICE_WAVEFORM_HEIGHT_PX = 32;
export const VOICE_WAVEFORM_BASELINE_HEIGHT = 1.08;
export const VOICE_WAVEFORM_STEP_MS = 80;
export const VOICE_WAVEFORM_OVERSCAN_BARS = 3;
export const VOICE_WAVEFORM_BAR_ENTER_DURATION_MS = 600;
export const VOICE_WAVEFORM_BAR_ENTER_DELAY_MS = 200;
export const VOICE_WAVEFORM_ZOOM_OUT_DURATION_MS = 1200;
export const VOICE_DURATION_WIDTH_PX = 42;

export const VOICE_WAVEFORM_CANVAS_WIDTH_PX =
  WEBSITE_CHAT_MAX_WIDTH_PX -
  CHAT_COMPOSER_HORIZONTAL_PADDING_PX -
  CHAT_COMPOSER_ACTION_GAP_PX -
  CHAT_COMPOSER_SEND_BUTTON_WIDTH_PX -
  VOICE_CONTROL_BUTTON_WIDTH_PX * 2 -
  VOICE_CONTROL_GROUP_GAP_PX * 3 -
  VOICE_DURATION_WIDTH_PX;
